import React, { Component } from 'react'

export default class ProcessingDiv extends Component {
    render() {
        return (
            <section className="loader">
                <div className="container">
                    <div className="center">
                        <span>
                            <img src="/assets/images/icons/chefpinlogo.svg" alt="Logo" />
                        </span>
                        <div className="loading_wrap">
                            <div className="loading_wrap">
                                <div className="loading-line-low"> </div>
                                <div className="loading-line-High"> </div>
                            </div>
                            <div className="text_wrap">
                                <p id="loading-text"> We are processing your order, Please wait...
                                    {/* <div className="wrap">
                                        <p className="point-loading1">.</p>
                                        <p className="point-loading2">.</p>
                                        <p className="point-loading3">.</p>
                                    </div> */}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
